import { useState, useEffect } from "react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { GEIFactorsTable } from "../../../components/Admin/ConfigForms/GEIFactorsTable";
import { useLanguage, useSite } from "../../../contexts";
import { useAuth } from "../../../hooks";
import { Permission, Site } from "../../../api";
import { Header, Segment, Icon } from "semantic-ui-react";
import "./GEIFactors.scss";

const permissionController = new Permission();
const siteController       = new Site();

export function GEIFactors() {
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [siteSelected,     setSiteSelected]     = useState(null);
  const [siteName,         setSiteName]         = useState("");
  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { site } = useSite();

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    setSiteSelected(site);
    if (!site) { setSiteName(""); return; }
    siteController.getSite(accessToken, site)
      .then(data => setSiteName(data?.name || ""))
      .catch(() => setSiteName(""));
  }, [site, accessToken]); // eslint-disable-line

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role, accessToken]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "configure", "view")
  ) {
    return (
      <div className="gei-factors-page">
        <Segment className="gei-factors-page__title">
          <Header as="h1">Factores GEI</Header>
        </Segment>
        {!siteSelected ? (
          <div className="no-site-warning">
            <Icon name="warning sign" size="big" />
            <p>{t("select_company_site_from_header")}</p>
          </div>
        ) : (
          <GEIFactorsTable site={siteSelected} siteName={siteName} />
        )}
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
